function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#2E84ED",
  fillRule: "evenodd",
  d: "M22.775 4.744l-4.52-4.52c-.3-.299-.784-.299-1.084 0l-3.369 3.369-11.339 11.34c-.125.128-.195.28-.217.438L.04 21.99c-.092.275-.02.58.185.784.145.148.342.226.542.226.08 0 .162-.013.242-.039l6.619-2.206c.16-.022.316-.094.438-.218l.01-.01.022-.021 10.157-10.157 4.52-4.52c.3-.3.3-.785 0-1.085zM7.13 19.304l-2.127.653c-.107-.402-.383-.95-.676-1.242-.293-.293-.866-.452-1.267-.559l.634-2.288 10.042-10.04.608-.608 3.435 3.435-10.65 10.65zM18.864 7.57l-3.435-3.435 2.285-2.284 3.435 3.435-2.285 2.284z"
});

const SvgComponent = props => React.createElement("svg", _extends({
  width: 23,
  height: 23,
  viewBox: "0 0 23 23"
}, props), _ref);

export default __webpack_public_path__ + "static/media/edit-pencil.42f86f1e.svg";
export { SvgComponent as ReactComponent };